import { Route, Routes } from "react-router-dom";

import { ExternalTaskPage } from "pages/external";
import { CalendarSubscribe } from "pages/calendar-subscribe";

import { OrganizationProvider } from "context/OrganisationContext";

import { ThemeWrapper } from "theme/theme-wrapper";

export const InitializeExternalApp = () => {
	return (
		<OrganizationProvider>
			<ThemeWrapper options={{ variants: ["jm", "xxl", "xl", "lg", "md", "sm", "xs"] }}>
				<Routes>
					{/* @deprecated, use :slug/user-tasks/:base64Email */}
					<Route path="user-tasks/:slug/:base64Email" element={<ExternalTaskPage />} />

					<Route path=":slug/*" element={<ExternalAppLayout />} />
				</Routes>
			</ThemeWrapper>
		</OrganizationProvider>
	);
};

const ExternalAppLayout = () => {
	return (
		<OrganizationProvider>
			<ThemeWrapper options={{ variants: ["jm", "xxl", "xl", "lg", "md", "sm", "xs"] }}>
				<Routes>
					<Route path="user-tasks/:base64Email" element={<ExternalTaskPage />} />
					<Route path="calendar/subscribe" element={<CalendarSubscribe />} />
				</Routes>
			</ThemeWrapper>
		</OrganizationProvider>
	);
};
